/*
  英语
*/
export default {
  PersonalCenter: {
    Store: {
      Index: {
        WhereToFind: 'Where to find',
        Tips1: '1. Login wordpress to manage backstage.',
        Tips2: '2. Go to: WooCommerce > Settings > Advanced > REST API > App key.',
        Tips3: '3. Fill in "Key details"',
        Description: 'Description',
        Tips4: 'give the key a name',
        User: 'User',
        Tips5: 'select the WooCommerce user that will be the author of the changes',
        Permissions: 'Permissions',
        SelectReadWrite: 'Select Read/Write',
        SelectGenerateAPIKey: 'Select Generate API Key',
        Tips6: 'Still confused？Check video description.',
        Tips7: 'Editing product information is only supported on the computer version',
        StoreURL: 'Store URL',
        StoreName: 'Store Name',
        ConsumerKey: 'Consumer Key',
        ConsumerSecret: 'Consumer Secret',
        DefaultDomain: 'Default Domain',
        Tips8: "You counld enter English letters,numbers,'-'and'_',Start and end with numbers or letters.",
        Tips9: 'Please enter your store name.',
        Tips10: 'Please enter your store url',
        Tips11: 'Please enter the consumerKey',
        Tips12: 'Please enter the consumerSecret',
        Tips13: 'TikTok platform docking internal test, so stay tuned'
      },
      SetStore: {
        DefaultShippingMethod: 'Default Shipping Method',
        Standard: 'Standard',
        Faster: 'Faster',
        Express: 'Express',
        Expedited: 'Expedited',
        ProfitMargin: 'Profit Margin',
        Profit: 'Profit',
        orderCustomization: 'Use the shipping method of the original order'
      }
    },
    Payment: {
      Index: {
        AvailableCredit: 'Available Credit',
        CreditLimit: 'Credit Limit',
        Tips1: "Sorry, you haven't had any transaction yet",
        Paypal: 'Paypal',
        Others: 'Others',
        Tips2: 'Please enter an amount between 0-9999999,allowed two decimal.'
      },
      BankCard: {
        Tips1: 'New order from your store will automatically checkout using the default payment method on file, and be fulfilled and shipped to your customers by KakaClo.',
        AddANewCard: 'Add a New Card',
        Remove: 'Remove',
        Tips2: 'Are you sure remove this Bank Card?',
        Confirm: 'Confirm',
        Cancel: 'Cancel'
      },
      Components: {
        AirwallexCard: {
          CardNumber: 'Card Number',
          SecurityCode: 'Security Code',
          ExpireDate: 'Expire Date',
          AcceptTheTerms: 'Accept the terms',
          Confirm: 'Confirm'
        }
      }
    },
    MyInformation: {
      Index: {
        CompanyInformation: 'Company Information',
        UNVERIFIEDBUYER: 'UNVERIFIED BUYER',
        Tips1: "Please upload your seller's permit to obtain full access. View your state's requirement",
        Here: 'here',
        UnderReview: 'Under Review',
        Tips2: 'If you already uploaded a permit on this page, please allow 24 business hours for your account to be reviewed. We will contact you via email. Contact Us below if you have difficulties in uploading below.',
        AuditFailure: 'Audit failure',
        AuthenticatedBuyer: 'Authenticated Buyer',
        Yes: 'Yes',
        No: 'No',
        Image: 'Image',
        DocumentOfProof: 'Document of Proof',
        DocumentProofOfBusiness: 'Document Proof of Business',
        Tips3: "Please upload seller's permit. Find your state's requirements",
        Upload: 'Upload',
        UploadFormat: 'Upload Format',
        CompanyAddress: 'Company Address',
        SaveChanges: 'Save Changes',
        Address: 'Address',
        City: 'City',
        StateProvince: 'State/Province',
        ZIPPostalCode: 'ZIP/Postal Code',
        Country: 'Country',
        Phone: 'Phone',
        FirstName: 'First Name',
        LastName: 'Last Name',
        CompanyName: 'Company Name',
        DoYouSellOnline: 'Do you sell online?',
        StoreURL: 'Store URL',
        SellerPermitNumber: 'Seller Permit Number',
        StorePicture: 'Store Picture',
        Tips4: 'Please enter your first name',
        Tips5: 'Please select Yes or No',
        Tips6: 'Please enter your address',
        Tips7: 'Please enter your last name',
        Tips8: "Please enter your company's name",
        Tips9: 'Please enter your city',
        Tips10: 'Please select the country',
        Tips11: 'Please Enter No More Than 20 Characters',
        Tips12: 'Save Change Success!'
      }
    },
    Components: {
      Tips1: 'Please be sure you have obtained the proper documents to do business in your state.',
      Tips2: "Please note that a seller's permit number is different than an EIN. If your state issues you the same number, please be ready to provide us with a copy of your completed resale certificate to show that your business is permitted to resell wholesale purchases.",
      Tips3: "States with no seller's permit number: Alaska, Delaware, Montana, New Hampshire, Oregon",
      Tips4: "Find your state's requirements"
    },
    AccountSetting: {
      Index: {
        NotVerified: 'not verified',
        ChangePassword: 'Change Password',
        Tips1: 'A Verification code has been sent to your email',
        Tips2: 'A verification code will be sent to your email',
        Tips3: 'You can resend the code after',
        later: 'later',
        Submit: 'Submit',
        EMailVerification: 'E-mail verification',
        FullName: 'Full Name',
        Email: 'Email',
        Phone: 'Phone',
        Password: 'Password',
        Tips4: 'A Verification code has been sent to your email',
        VerificationCode: 'Verification Code',
        Send: 'Send',
        ConfirmPassword: 'Confirm Password',
        Tips5: 'Please enter your valid phoneNumber',
        Tips6: 'Please enter the password again',
        Tips7: 'The two passwords are inconsistent!',
        Tips8: 'Please input Verification Code'
      },
      Components: {
        AccountSettingDialog: {
          Tips1: 'A Verification code has been sent to your email',
          Tips2: 'You can resend the code after',
          later: 'later',
          ChangePassword: 'Change password',
          VerificationCode: 'Verification Code',
          Password: 'Password',
          ConfirmPassword: 'Confirm Password',
          Tips3: 'Please enter your valid phoneNumber',
          Tips4: 'Please enter the password again',
          Tips5: 'The two passwords are inconsistent!',
          Tips6: 'Please input Password',
          Tips7: 'Please click Send verification code'
        }
      }
    },
    ApiSet: {
      Token: 'Token',
      MaturityTime: 'Maturity Time',
      Check: 'Check',
      RenewToken: 'Renew Token',
      Confirm: 'Confirm',
      Cancel: 'Cancel',
      hint1: 'Please enter your login password',
      hint2: 'The key can be updated if the validity period is less than 7 days',
      APIDocument: 'API Document',
      SigningSecret: 'Signing Secret',
      webHookHint1: 'Please enter your callback URL',
      Submit: 'Submit',
      Show: 'Show',
      Hide: 'Hide',
      webHookHint2: 'Please enter the website that starts with https'
    }
  }
}
